<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Dealers & Front Offices</h2>
    </div>

    <div class="tds-row">
        <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
            <tds-table-toolbar filter>
            </tds-table-toolbar>
            <tds-table-header>
                <tds-header-cell cell-key='coD_ORIGINAL' cell-value='#' sortable></tds-header-cell>
                <tds-header-cell cell-key='concNome' cell-value='Concessionário' sortable></tds-header-cell>
            </tds-table-header>
            <tds-table-body>
                <tds-table-body-row>
                    <tds-body-cell cell-key="coD_ORIGINAL">12344</tds-body-cell>
                    <tds-body-cell cell-key="concNome">BRASD.CAXIAS (3)</tds-body-cell>
                </tds-table-body-row>
            </tds-table-body>
        </tds-table>
    </div>
</div>